/**
 * @license lucide-vue-next v0.577.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createLucideIcon from '../createLucideIcon.js';

const LineDotRightHorizontal = createLucideIcon("line-dot-right-horizontal", [
  ["path", { d: "M 3 12 L 15 12", key: "ymhu98" }],
  ["circle", { cx: "18", cy: "12", r: "3", key: "1kchzo" }]
]);

export { LineDotRightHorizontal as default };
//# sourceMappingURL=line-dot-right-horizontal.js.map
